import { Button } from '@/components/ui/button';

interface PipelineStallBannerProps {
  isStalled: boolean;
  isRecording: boolean;
  onRecover: () => Promise<void>;
}

export const PipelineStallBanner = ({ isStalled, isRecording, onRecover }: PipelineStallBannerProps) => {
  if (!isStalled || !isRecording) return null;

  return (
    <div className="mx-2 mb-2 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-amber-800 text-sm">
      <span className="flex-1">Hljóðupptaka stöðvaðist. Smelltu til að halda áfram.</span>
      <Button
        variant="outline"
        size="sm"
        onClick={onRecover}
        className="border-amber-400 text-amber-700 hover:bg-amber-100"
      >
        Endurræsa
      </Button>
    </div>
  );
};
